let apiUrl = "";
const env = process.env.NODE_ENV;
switch (env) {
  case "development":
    apiUrl = process.env.MIX_APP_API_URL ?? "http://localhost:3000/api/v1";
    break;
  case "production":
    apiUrl = "https://ead.professorlucassilva.com.br/api/v1";
    break;
  case "beta":
    apiUrl = "https://ead.professorlucassilva.com.br/api/v1";
    break;
}
export const CONFIG = {
  SERVICE_WORKER_QUERY_STRING: "?v=2",
  G4_ANALYTICS_ID: process.env.MIX_G4_ANALYTICS_ID,
  ANALYTICS_ID: process.env.MIX_ANALYTICS_ID,
  CACHEV: "v2",
  GOOGLE_APP_CLIENT_ID:
    "940270095436-vviiia5pjujt2o2s13fu9gnu0moqbu17.apps.googleusercontent.com",
  FACEBOOK_APP_CLIENT_ID: "2322565484690094",
  API_URL: apiUrl,
  PAYPAL_ENVIRONMENT:
    process.env.NODE_ENV !== "production" ? "sandbox" : "production",
  PAYPAL_CREDENTIALS: {
    sandbox:
      "AdimilhPzKaRu4hcf96R7Yw8ETXBFJhw2zbgNjrBplefwAiigmx2ZZ00TzjTl018waoOFSiGdMB3tnmR",
    production:
      "Acj70vSuYfCwwbR3oXzIVdUl0BUFDEqmdyXfNTS75edX4DiLka0-VTow3vfnvWTpk-gIERtp1lRlLBlh",
  },
  PAYPAL_EXPERIENCE_OPTIONS: {
    input_fields: {
      no_shipping: 1,
    },
    flow_config: {
      landing_page_type: "Billing",
      user_action: "commit",
    },
  },
  PAYPAL_BUTTON_STYLE: {
    label: "checkout",
    size: "responsive",
    shape: "rect",
    color: "gold",
    tagline: "false",
    fundingicons: "true",
    height: 40,
  },
  USE_PLYR: false,
  BUGSNAG_API_KEY: process.env.MIX_BUGSNAG_FRONT_API_KEY,
  CAPTCHA_SITE_KEY: process.env.MIX_CAPTCHA_SITE_KEY,
  ABLY_PUBLIC_KEY: process.env.MIX_ABLY_PUBLIC_KEY,
};
